import useSafeState from '../../utils/safe-state';
import { Button, Form, Modal, Select } from 'antd';
import React, { ReactElement } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useAxios } from '../../utils/hooks';
import { notif } from '../../utils/notif';
import {AxiosError, AxiosResponse} from "axios";
import { Trans } from '@lingui/macro';

const { confirm } = Modal;

interface Interface {
    title?: ReactElement;
    children: ReactElement;
    onCustomClose?: () => void;
    customClose?: () => void;
    name?: string;
}

const RoleSettingForm = (props: Interface) => {
    const axiosInstance = useAxios(process.env.REACT_APP_API_BASE_URL + "");

    const [visible, setVisible] = useSafeState(false);
    const [role, setRole] = useSafeState('');
    const [mode, setMode] = useSafeState('Edit');
    const [form] = Form.useForm();
    form.resetFields();

    let selectedRole: any = [];

    type optionalType = {
        label: string;
        value: string;
    };

    const getRoleFriendlyName = (roleCode: string): string => {
        const roleMap: { [key: string]: string } = {
            'EUDR_SUPPL_USER': 'General Role',
            'EUDR_SUPPL_ADMIN': 'Supplier Admin Role',
        };
        return roleMap[roleCode] || roleCode;
    };

    const generateRoleOptions = (data: any): optionalType[] => {
        let arrayToOptions = new Array<optionalType>();
        for (var i = 0; i < data.length; i++) {
            if (!data[i].startsWith('EUDR_')) {
                continue;
            }

            let currentItem: optionalType = {
                value: data[i],
                label: getRoleFriendlyName(data[i]),
            };
            arrayToOptions.push(currentItem);
        }
        return arrayToOptions;
    };

    const handleOnChange = (value: any) => {
        console.log(value);
        selectedRole = [];
        selectedRole.push(value);
        setRole(value);
    };

    const open = (mode?: 'Add new' | 'Edit' | '', recordData?: any) => {
        setMode(mode ? mode : '');
        setVisible(true);
    };

    const addRoleCall = (id: any, role: any) => {
        if (!axiosInstance.current) {
            return;
        }

        if(axiosInstance.current != null) {

            axiosInstance.current.put("/resource/userrole/add-roles?id=" + id + "&role=" + role, {})
                .then(function (response : AxiosResponse<any>) {
                    console.log(response.data);
                }).catch(function (error :AxiosError) {
                console.log(error)
            });
        }

        console.log(id, selectedRole);
    };

    const showPromiseConfirm = (recordData?: any) => {
        confirm({
            title: props.title,
            icon: <ExclamationCircleOutlined />,
            content: (
                <Select
                    allowClear
                    showSearch={true}
                    style={{ width: '100%' }}
                    placeholder={recordData.role}
                    options={generateRoleOptions(recordData.roles)}
                    onChange={(value: any) => handleOnChange(value)}
                />
            ),
            visible: visible,
            onOk() {
                return new Promise((resolve, reject) => {
                    setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
                    addRoleCall(recordData.userId, selectedRole);
                }).catch(() => console.log('Oops error!'));
            },
            onCancel() {},
        });
    };

    return { open, showPromiseConfirm };
};
export default RoleSettingForm;
